(function () {
  var SELECTOR = '[data-zen-customer-city]';
  var CACHE_KEY = 'zen_customer_city';

  function targets() {
    var elements = document.querySelectorAll(SELECTOR);
    var matches = [];

    for (var i = 0; i < elements.length; i++) {
      var value = (elements[i].textContent || '').trim().toLowerCase();

      if (value === 'your area' || elements[i].getAttribute('data-zen-city') === 'true') {
        matches.push(elements[i]);
      }
    }

    return matches;
  }

  function setCity(city) {
    if (!city) return;

    var elements = targets();

    for (var i = 0; i < elements.length; i++) {
      elements[i].textContent = city;
      elements[i].setAttribute('data-zen-city', 'true');
    }
  }

  function cachedCity() {
    try {
      return sessionStorage.getItem(CACHE_KEY);
    } catch (error) {
      return null;
    }
  }

  function saveCity(city) {
    try {
      sessionStorage.setItem(CACHE_KEY, city);
    } catch (error) {
      // Keep the fallback when storage is unavailable.
    }
  }

  function fetchCity() {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller
      ? setTimeout(function () {
          controller.abort();
        }, 3000)
      : null;

    return fetch('https://ipwho.is/', {
      method: 'GET',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Location lookup failed');
        return response.json();
      })
      .then(function (data) {
        if (!data || typeof data.city !== 'string' || !data.city.trim()) {
          throw new Error('City unavailable');
        }

        return data.city.trim();
      })
      .finally(function () {
        if (timeout) clearTimeout(timeout);
      });
  }

  function fallbackCity() {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var previousCallback = window.geoip;
      var finished = false;

      function cleanup() {
        if (script.parentNode) script.parentNode.removeChild(script);

        if (typeof previousCallback === 'function') {
          window.geoip = previousCallback;
        } else {
          try {
            delete window.geoip;
          } catch (error) {
            window.geoip = undefined;
          }
        }
      }

      var timeout = setTimeout(function () {
        if (finished) return;
        finished = true;
        cleanup();
        reject(new Error('Fallback timed out'));
      }, 1800);

      window.geoip = function (data) {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        cleanup();

        if (data && typeof data.city === 'string' && data.city.trim()) {
          resolve(data.city.trim());
        } else {
          reject(new Error('City unavailable'));
        }
      };

      script.async = true;
      script.src = 'https://get.geojs.io/v1/ip/geo.js';
      script.onerror = function () {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        cleanup();
        reject(new Error('Fallback failed'));
      };

      document.head.appendChild(script);
    });
  }

  function loadCity() {
    if (!targets().length) return;

    var cached = cachedCity();

    if (cached) {
      setCity(cached);
      return;
    }

    fetchCity()
      .catch(fallbackCity)
      .then(function (city) {
        saveCity(city);
        setCity(city);
      })
      .catch(function () {
        // "your area" remains visible when location is unavailable.
      });
  }

  function schedule() {
    setTimeout(loadCity, 350);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }

  document.addEventListener('shopify:section:load', loadCity);
})();